<template>
  <popup :close-action="closeModal">
    <template v-slot:title>
      <div class="title">
        לא הצלחת להיכנס לשירות?
      </div>
    </template>
    <template v-slot:content>
      <div class="text">
        צריך רק למלא את הפרטים והצוות שלנו ייצור איתך קשר בהקדם האפשרי כדי לפתור את הבעיה.
      </div>
      <div class="form">
        <text-input
          :autofocus="true"
          :labelText="'שם מלא'"
          :on-input="nameEntered"
          :value="fullName"
          :error="nameError.length > 0"
          :top-left-label="nameError"
        />
        <text-input
          :labelText="'מספר טלפון'"
          :on-input="numberEntered"
          :value="phoneNumber"
          :inputType="'text'"
          :inputPattern="'\\d*'"
          :error="phoneError.length > 0"
          :top-left-label="phoneError"
        />
      </div>
      <div v-if="messageSent" class="message-sent">
        תודה, נחזור אליך בהקדם!
      </div>
      <riseup-button v-else
                     class="done-btn"
                     :action="() => submit()"
                     :title="'שליחה'"/>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import LoginApi from '../../../../../api/LoginApi';
import DDLogs from '../../../../../DDLogs';

export default {
  name: 'LoginHelp',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    textInput: BaseUI.TextInput,
    Popup: BaseUI.Popup,
  },
  data() {
    return {
      fullName: '',
      phoneNumber: '',
      nameError: '',
      phoneError: '',
      messageSent: false,
    };
  },
  computed: {
    hasErrors() {
      return this.nameError || this.phoneError;
    },
  },
  methods: {
    async closeModal() {
      this.$emit('close');
    },
    async submit() {
      this.resetErrors();
      this.validateName();
      this.validateNumber();
      const customerDetails = { phoneNumber: this.phoneNumber, fullName: this.fullName };
      if (!this.hasErrors) {
        try {
          await LoginApi.loginHelpLead(customerDetails);
          this.replaceButton();
        } catch (error) {
          DDLogs.error('Customer needs help logging in but lead creation failed', customerDetails);
          this.replaceButton();
          throw new Error(`Customer needs help logging in but lead creation failed [name=${this.fullName}] [number=${this.phoneNumber}]`);
        }
      }
    },
    resetErrors() {
      this.nameError = '';
      this.phoneError = '';
    },
    validateName() {
      if (this.fullName.length < 2) {
        this.nameError = 'יש להכניס שם מלא';
      }
    },
    validateNumber() {
      if (!this.phoneNumber.match(/^0[0-9]{9}$/)) {
        this.phoneError = 'מספר הטלפון אינו תקין';
      }
    },
    nameEntered(value) {
      this.nameError = '';
      this.fullName = value;
    },
    numberEntered(value) {
      this.phoneError = '';
      this.phoneNumber = value;
    },
    replaceButton() {
      this.messageSent = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .title {
    font-size: 24px;
    font-weight: bold;
  }

  .text {
    margin: 30px 0px;
    font-size: 16px;
    line-height: 22px;
  }

  .done-btn {
    margin-top: 25px;
    width: 100%;
  }

  .message-sent {
    padding: 15px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    color: $riseup_light_blue;
  }
</style>
